const handleUploadImage = async (
  file: File,
  uploadUrl: string,
  id: string
): Promise<string | undefined> => {
  const formData = new FormData();
  formData.append('file', file);

  try {
    const response = await fetch(uploadUrl, {
      method: 'POST',
      body: formData,
    });

    if (!response.ok) {
      throw new Error(`Image upload failed with status ${response.status}.`);
    }

    return id;
  } catch (error) {
    console.error(error);
  }
};

export { handleUploadImage };
